import React from 'react';

import cx from 'classnames';

import { AIActions } from 'components/Pages/Admin/Page/common/AIPageGeneration/AIActions';
import { usePageGenerationContext } from 'components/Pages/Admin/Page/common/AIPageGeneration/PageGenerationContext';
import Button from 'components/shared/Button';
import Drawer from 'components/shared/Drawer';
import Modal from 'components/shared/Modal';

import CodeRedactor from './CodeRedactor';
import CustomFonts from './CustomFonts';
import s from './index.module.css';
import useActions from './useActions';

const CSSActions = ({ isItinerariesItem, isShowAIActions }) => {
  const {
    handleOpenCuctomCss,
    handleOpenFontsModal,
    handleCloseFontsModal,
    openDrawer,
    handleCloseDrawer,
    openFontsModal,
  } = useActions();

  return (
    <div className={cx(s.cssWrapper, isShowAIActions && s.cssWrapperWithAI)}>
      <Drawer isOpen={openDrawer} toClose={handleCloseDrawer}>
        <CodeRedactor onClose={handleCloseDrawer} isItinerariesItem={isItinerariesItem} />
      </Drawer>
      <Modal isOpen={openFontsModal} toClose={handleCloseFontsModal}>
        <CustomFonts isItinerariesItem={isItinerariesItem} />
      </Modal>
      <div className={s.left} />

      <div className={s.right}>
        <Button className={s.cssButton} size="small" type="default" onClick={handleOpenFontsModal}>
          Custom Fonts
        </Button>
        <Button className={s.cssButton} size="small" type="default" onClick={handleOpenCuctomCss}>
          Custom CSS
        </Button>
      </div>
    </div>
  );
};

const Actions = (props) => {
  const { withNav = false, isItinerariesItem, isCustomCSSEnabled, wrapperClassName, noTopPadding } = props;
  const { isShowAIActions } = usePageGenerationContext();

  const isShowEmptyTop = !isShowAIActions && !isCustomCSSEnabled && !noTopPadding;
  const wrapperClasses = cx(s.wrapper, withNav && s.wrapperWithNav, wrapperClassName && wrapperClassName);

  if (isShowEmptyTop) {
    return <div className={s.emptyTop} />;
  }

  return (
    <div className={wrapperClasses}>
      {isCustomCSSEnabled && <CSSActions isItinerariesItem={isItinerariesItem} isShowAIActions={isShowAIActions} />}
      {isShowAIActions && <AIActions />}
    </div>
  );
};

export default Actions;
